export default "__VITE_ASSET__8189345d__"